<template>
    <div>
        <!-- NAV MOBILE -->
        <nav class="fixed-top navbar-light bg-light menu-sm">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <button class="navbar-toggler hamb" type="button" data-toggle="collapse" data-target="#menu-mb" aria-controls="menu-mb" aria-expanded="false" aria-label="Toggle navigation">
                            <img src="../assets/icons/Icon material-menu.png" class="img-fluid">
                        </button>
                    </div>
                    <div class="col text-center">
                        <router-link to="/"><img src="../assets/logos/ed.financeira.png" class="img-fluid mitanga"></router-link>
                    </div>
                    <div class="col text-right">
                        <button class="navbar-toggler login" type="button" data-toggle="collapse" data-target="#menu-login" aria-controls="menu-login" aria-expanded="false" aria-label="Toggle navigation">
                            <img src="../assets/icons/login.png" class="img-fluid">
                        </button>
                    </div>
                </div>
                <div class="row menu-escondido">
                    <div class="col">
                        <div class="collapse navbar-collapse" id="menu-mb">
                            <ul class="navbar-nav mr-auto">
                                <h5>Menu</h5>
                                <li class="nav-item bold">
                                    Coleções
                                </li>
                                <li class="nav-item">
                                    <router-link class="nav-link" to="/anos-iniciais">Ensino Fundamental - Anos Iniciais</router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link class="nav-link" to="/anos-finais">Ensino Fundamental - Anos Finais</router-link>
                                </li>
                                <li class="nav-item bold">
                                    <router-link class="nav-link" to="/contato">Contato</router-link>
                                </li>
                            </ul>
                            <div class="menu-social">
                                <div class="d-inline socials">
                                    <a href="https://www.facebook.com/editoradobrasil/" target="_blank"><img src="../assets/icons/facebook-square-brands.png" class="img-fluid"></a>
                                </div>
                                <div class="d-inline socials">
                                    <a href="https://www.instagram.com/editoradobrasil_oficial/" target="_blank"><img src="../assets/icons/instagram-brands.png" class="img-fluid"></a>
                                </div>
                                <div class="d-inline socials">
                                    <a href="https://www.youtube.com/user/EditoradoBrasil/" target="_blank"><img src="../assets/icons/youtube-brands.png" class="img-fluid"></a>
                                </div>
                                <div class="d-inline socials">
                                    <a href="https://lojavirtual.editoradobrasil.com.br/" target="_blank"><img src="../assets/icons/shopping-cart-solid.png" class="img-fluid"></a>
                                </div>
                            </div>
                        </div>
                        <div class="collapse navbar-collapse" id="menu-login">
                            <ul class="navbar-nav mr-auto text-right">
                                <li class="nav-item bold">
                                    <a class="nav-link" target="_blank" href="https://www.editoradobrasil.com.br/sistemas/cadastro">Cadastre-se</a>
                                </li>
                                <li class="nav-item bold">
                                    <a class="nav-link" target="_blank" href="https://editoradobrasil.com.br/leb/login">Login</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <!-- NAV DESKTOP -->
        <nav class="navbar-expand-lg fixed-top navbar-light bg-light menu-md">
            <div class="container">
                <div class="row">
                    <div class="col-sm-1">
                        <ul class="navbar-nav mr-auto">
                            <li class="menu-esq nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <img src="../assets/icons/Icon material-menu.png" class="img-fluid">
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <router-link class="dropdown-item" to="/anos-iniciais">Ensino Fundamental - Anos Iniciais</router-link>
                                <div class="dropdown-divider"></div>
                                <router-link class="dropdown-item" to="/anos-finais">Ensino Fundamental - Anos Finais</router-link>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="http://www.editoradobrasil.com.br/faleconosco/" target="_blank" rel="noopener noreferrer">Contato</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm text-left">
                        <router-link to="/"><img src="../assets/logos/ed.financeira.png" class="img-fluid"></router-link>
                        <router-link to="/"><img src="../assets/imagens/selo.png" style="max-width: 80px;"></router-link>
                    </div>
                    
                    <div class="col-sm">
                        <div class="float-right">
                            <ul class="navbar-nav">
                                <li class="nav-item">
                                    <a class="nav-link" target="_blank" href="https://editoradobrasil.com.br/leb/login"><b>LOGIN</b></a>
                                </li>
                                <li class="nav-item">
                                    <a class="btn btn-cadastro" target="_blank" href="https://www.editoradobrasil.com.br/sistemas/cadastro">Cadastre-se</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        name: 'Navbar'
    }
</script>